import { createFeatureSelector, createSelector } from '@ngrx/store';
import { NewInboxState } from '../reducers/new-inbox.reducer';

const featureState = createFeatureSelector<NewInboxState>('newInbox');

export const selectNewInboxActionLoading = createSelector(
  featureState,
  (state) => state.actionLoading,
);
export const selectNewInboxActiveTabIndex = createSelector(
  featureState,
  (state) => state.activeTabIndex,
);
export const selectCompanyInboxState = createSelector(featureState, (state) => state?.companyInbox);
export const selectTabs = createSelector(featureState, (state) => state.tabs);
// EMAILS
export const selectInboxEmails = createSelector(featureState, (state) => ({
  items: state.companyInbox.emails,
  totalCount: 0,
}));

export const selectInboxEmailsFilter = createSelector(featureState, () => null);
// FAXES
export const selectInboxFaxesFilter = createSelector(featureState, () => null);

export const selectInboxFaxes = createSelector(featureState, (state) => ({
  items: state.companyInbox.faxes,
  totalCount: 0,
}));

// TEMPLATES
export const selectInboxTemplates = createSelector(featureState, (state) => ({
  items: state.templates,
  totalCount: 0,
}));
export const selectInboxTemplatesFilter = createSelector(featureState, () => null);

export const isEditMode = createSelector(featureState, (state) => state.isEditMode);
